var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHardDrive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "hard_drive_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#hard_drive_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M28.334 26.666c.694 0 1.285-.236 1.77-.708.487-.472.73-1.07.73-1.792 0-.694-.243-1.284-.73-1.77a2.411 2.411 0 0 0-1.77-.73c-.722 0-1.32.243-1.792.73a2.447 2.447 0 0 0-.708 1.77c0 .723.236 1.32.708 1.792.473.472 1.07.708 1.792.708ZM3.334 15l5.667-5.667a3.53 3.53 0 0 1 1.062-.73c.403-.18.84-.27 1.313-.27h17.208c.472 0 .91.09 1.313.27.402.181.756.424 1.062.73L36.667 15H3.334Zm3.333 16.666c-.944 0-1.736-.32-2.375-.958-.639-.639-.958-1.43-.958-2.375v-10h33.333v10c0 .945-.326 1.736-.979 2.375a3.245 3.245 0 0 1-2.354.958H6.667Z"
}))));
export default SvgHardDrive;